/*
创建者 左晨(2019.07.27)
奖金积分提现页面
*/
<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      >
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>奖金积分提现 (余额{{bonusValue}})</h2>
        <div class="content">
          <!--  <p style="margin-bottom: 10px;">可提现金额：{{bonusValue}}</p> -->
          <form
            action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253"
            name="transferForm"
            class="alipayform"
            method="POST"
            target="_blank"
          >
            <div class="element">
              <div class="etitle">银行卡提现</div>
              <div class="msgbox">
                <p>
                  <span class="tit">提现金额：</span>
                  <input
                    type="text"
                    maxlength="60"
                    class="input"
                    name="payCode"
                    placeholder="请输入提现金额(需100整数倍)"
                    v-model="reflectMoney"
                    style="ime-mode:Disabled;"
                    @input="getCalGold"
                  >
                  <span
                    v-if="calGold"
                    style="margin-left: 10px; color: #ff0000;"
                  >税后实际提交金额：{{calGold}}</span>
                </p>
                <p><span class="tit">姓名：</span>
                  <input
                    type="text"
                    maxlength="60"
                    class="input"
                    name="payCode"
                    v-model="idName"
                  >
                </p>
                <p><span class="tit">身份证号码：</span>
                  <input
                    type="text"
                    maxlength="60"
                    class="input"
                    name="payCode"
                    v-model="idNumber"
                  >
                </p>
                <div class='ptb5 flowhid'>
                  <p><span class="tit">身份证照片：</span></p>
                  <div class='img_box'>
                    <div>
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :on-success="handleFontImgSuccess"
                        :format="['jpg','jpeg','png']"
                        :headers='{"Auth-Token": upHeaders}'
                        :on-format-error="handleFormatError"
                        :before-upload="handleBeforeUpload"
                        type="drag"
                        :action="UploadUrl()"
                      >
                        <input
                          type="hidden"
                          v-model='idFrontImage'
                        >
                        <img
                          :src='(idFrontImageUrl || idFrontImage)?(idFrontImageUrl || idFrontImage):defaultFontUrl'
                          :class="noFrontImg == true?'no-img':''"
                        >
                        <span>证件正面</span>
                      </Upload>
                    </div>
                    <div>
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :on-success="handleBackImgSuccess"
                        :format="['jpg','jpeg','png']"
                        :headers='{"Auth-Token": upHeaders}'
                        :on-format-error="handleFormatError"
                        :before-upload="handleBeforeUpload"
                        type="drag"
                        :action="UploadUrl()"
                      >
                        <input
                          type="hidden"
                          v-model='idBackImage'
                        >
                        <img
                          :src='(idBackImageUrl || idBackImage)?(idBackImageUrl || idBackImage):defaultBackUrl'
                          :class="noBackImg == true?'no-img':''"
                        >
                        <span>证件反面</span>
                      </Upload>
                    </div>
                  </div>
                </div>
                <div class='clear'></div>
                <p><span class="tit">支付宝姓名：</span>
                  <input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="trueName"
                  >
                </p>
                <p><span class="tit">支付宝账号：</span>
                  <input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="alipayName"
                  >
                </p>
                <p><span class="tit">验证码：</span><input
                    type="text"
                    maxlength="6"
                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
                    class="input"
                    v-model="payCode"
                  ><span
                    class="code-sty"
                    @click="getCodeHandler"
                    v-show="codeShow"
                  >获取验证码</span>
                  <span
                    class="code-sty grey-sty"
                    v-show="!codeShow"
                  >{{count}} s</span>
                </p>
                <p>
                  <span class="tit">
                    <div
                      class="tit_inner"
                      style='top:0;'
                    >留言信息：</div>
                  </span>
                  <textarea
                    name="content"
                    class="ivu-input bonusTextArea"
                    placeholder=""
                    v-model="messageContent"
                    maxlength="500"
                  ></textarea>
                </p>
                <p>
                  <input
                    type="button"
                    @click="confirmBankCash"
                    class="yellow_btn"
                    value="立即提现"
                  >
                </p>
              </div>
            </div>
          </form>
          <div style="margin-top: 30px;">
            提现规则:<br />
            <span style="color: red">为便于申报税费，每月5号、10号、15号、20号开放提现功能，其他时间不能提现。</span><br />
            根据国家对企业上市规范要求和按国家税务个人劳务报酬所得税收预扣预缴税率表:<br>
            1、当月累计提现不超过20000元的，按照税法扣除20%的税费:<br>
            2、当月累计提现不超过20000元至50000元的部分，按照税法扣除30%的税费;<br>
            3、当月累计提现超过50000元的部分，按照税法扣除40%的税费。"
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import {
  userWithdrawAlipay,
  getWithdrawUserInfo,
  getCalGoldWithdraw,
} from "api/user";
import { getSettleCode } from "api/order";
import { getSession, getNowFormatDate } from "utils/tool";
import { encryptDes } from "utils/des";

const NodeRSA = require("node-rsa");

export default {
  data() {
    return {
      cashnum: "",
      realName: "",
      trueName: "",
      alipayAccount: "",
      paypassword: "",
      bonusValue: "",
      bankUserName: "",
      bankOpenAddress: "",
      bankList: [],
      selectBank: "",
      //questionList: [],
      selectQuestion: "",
      messageContent: "",
      userOfBankId: "",
      reflectMoney: "",
      bankId: "",
      verifyPwd: "",
      payCode: "",
      pwdQuestionId: "",
      alipayName: "",
      bankUserNo: "",
      calGold: undefined,
      timer: undefined,
      noFrontImg: true,
      noBackImg: true,
      uploadList: [],
      idName: "",
      idNumber: "",
      idFrontImage: "",
      idBackImage: "",
      idFrontImageUrl: "",
      idBackImageUrl: "",
      defaultFontUrl: require("../../assets/images/idFontcard.png"),
      defaultBackUrl: require("../../assets/images/idBackcard.png"),
      localUrl: "",
      file: "",
      upHeaders: "",
      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
      timerCode: null,
      codeShow: true,
      count: "",
    };
  },
  created() {
    this.timer = null;
    this.alipayAccount = "";
    this.paypassword = "";
    this.bonusValue = this.$route.query["bonusValue"];
    this.getUserBankInfo();
    this.getUpHeaders();
  },
  methods: {
    // 获取验证码点击
    getCodeHandler() {
      this.getRegisterCode();
    },
    // 获取支付验证码
    getRegisterCode() {
      //verificationCodeType："0"：支付验证码 "1"：找回密码验证码 "2"：注册验证码
      let TIME_COUNT = 60;
      if (!this.timerCode) {
        let data = {
          type: 5,
        };
        getSettleCode(data).then((res) => {
          if (res.resCode == 1) {
            layer.msg("验证码已发送！", { icon: 1 });
          } else {
            layer.msg(res.resDesc, { icon: 2 });
          }
        });
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timerCode = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timerCode);
            this.timerCode = null;
          }
        }, 1000);
      }
    },
    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },
    getCalGold() {
      this.reflectMoney = this.reflectMoney.replace(/[^\d]/g, ""); // 清除“数字”和“.”以外的字符
      if (this.reflectMoney.indexOf(".") < 0 && this.reflectMoney != "") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.reflectMoney = parseInt(this.reflectMoney);
      }
      if (!this.reflectMoney) {
        this.calGold = undefined;
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        let data = {
          loginName: getSession("userName"),
          money: this.reflectMoney,
          type: 1,
        };
        getCalGoldWithdraw(data).then((res) => {
          if (res.resCode == 1) {
            this.calGold = res.data;
          }
        });
      }, 1000);
    },

    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/common/upload";
      return actionPath;
    },
    //上传成功
    handleFontImgSuccess(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        this.noFrontImg = false;
        this.idFrontImage = res.data.fileUrl;
        this.idFrontImageUrl = this.localUrl;
      } else {
        return;
      }
    },
    handleBackImgSuccess(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        this.noBackImg = false;
        this.idBackImage = res.data.fileUrl;
        this.idBackImageUrl = this.localUrl;
      } else {
        return;
      }
    },
    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg和png.",
      });
    },
    //上传文件大小限制
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "文件太大,不能超过 5M.",
      });
    },
    //存储本地图片展示
    handleBeforeUpload(file) {
      this.file = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const _base64 = reader.result;
        this.localUrl = _base64;
      };
    },
    getUserBankInfo() {
      const postJson = {
        userName: getSession("userName"),
        type: 1,
      };
      getWithdrawUserInfo(1, postJson).then((json) => {
        //   this.bankUserName = json.data.bankUserName;
        //   this.bankOpenAddress = json.data.bankOpenAddress;
        this.bankList = json.data.bankList;
        //this.questionList = json.data.questionList;
        this.bankId = json.data.bankId;
        //   this.bankUserNo = json.data.bankUserNo;
        this.userOfBankId = json.data.userOfBankId;
        this.alipayName = json.data.alipayName;
        this.trueName = json.data.realName;
        this.idName = json.data.idName;
        this.idNumber = json.data.idNumber;
        this.idFrontImage = json.data.idFrontImage;
        this.idBackImage = json.data.idBackImage;
        let idFrontImageUrl = json.data.idFrontImageUrl;
        if (idFrontImageUrl) {
          this.idFrontImageUrl = idFrontImageUrl;
          this.noFrontImg = false;
        }
        let idBackImageUrl = json.data.idBackImageUrl;
        if (idBackImageUrl) {
          this.idBackImageUrl = idBackImageUrl;
          this.noBackImg = false;
        }
      });
    },
    confirmBankCash() {
      if (this.reflectMoney == "" || this.reflectMoney == undefined) {
        this.$Message.warning("请输入提现金额！");
        return;
      }
      if (this.idName == "" || this.idName == undefined) {
        this.$Message.warning("请输入姓名！");
        return;
      }
      if (
        !this.idNumber ||
        !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idNumber)
      ) {
        this.$Message.warning("身份证号格式错误！");
        return;
      }
      if (this.idFrontImage == "" || this.idFrontImage == undefined) {
        this.$Message.warning("请上传身份证的正面照！");
        return;
      }
      if (this.idBackImage == "" || this.idBackImage == undefined) {
        this.$Message.warning("请上传身份证的反面照！");
        return;
      }
      if (this.trueName == "" || this.trueName == undefined) {
        this.$Message.warning("请输入支付宝姓名！");
        return;
      }
      if (this.alipayName == "" || this.alipayName == undefined) {
        this.$Message.warning("请输入支付宝账号！");
        return;
      }
      //   if (this.pwdQuestionId == '' || this.pwdQuestionId == undefined) {
      //        this.$Message.warning('请选择密码验证问题！');
      //        return;
      //   }
      if (this.payCode == "" || this.payCode == undefined) {
        this.$Message.warning("请输入短信验证码！");
        return;
      }

      //联盟商家是100的倍数,最低100
      if (this.reflectMoney % 1 != 0) {
        this.$Message.warning("金额必须是大于100的整数倍！");
        return;
      }
      if (this.reflectMoney < 100) {
        this.$Message.warning("提现最少不能低于100！");
        return;
      }

      let self = this;
      var lock = false;
      layer.confirm(
        "是否确定提现?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            let postJson = {
              loginName: getSession("userName"),
              type: 1,
              amount: self.reflectMoney,
              // "userOfBankId": self.userOfBankId,
              // "bankUserName": self.bankUserName,
              // "bankOpenAddress": self.bankOpenAddress,
              // "bankId": self.bankId,
              // "bankUserNo": self.bankUserNo,
              name: self.idName,
              number: self.idNumber,
              imageFront: self.idFrontImage,
              imageBack: self.idBackImage,
              alipayName: self.alipayName,
              // pwdQuestionId: self.pwdQuestionId,
              paymentCode: self.payCode,
              messageContent: self.messageContent,
              alipayRealName: self.trueName,
            };
            const publicKey =
              process.env.NODE_ENV == "production"
                ? `
  -----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCWQyWB209I+D7cQPe34hrIxUxT
  yQ377RDOVwGDVsZk/U3ijpp/evHrPxaCZm9xAPU39CDRcNhnxTj3wb4q0FDMd5cP
  yFbhiUriqozdgjqNFMi6cbThzWPJMY4a9y4WL46OPHKWvc297iu0ZSs/75pie6YN
  2clvS4Job4NyAIOqOQIDAQAB
  -----END PUBLIC KEY-----
  `
                : `
  -----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCmf6yguu3jAEXivJYOeKVJiKdN
  xWS+fULvUNJTkmSFOYZQ13ATgKGDcFYOqI2eu7bwgUSI8kY2XuMHDViT7ggtbNfc
  6O8XuL33ZaJvBry3zbfycyyr0EEF0ziPAQlvlnlWOrLlBrUPESuqkFArnQfpNHpY
  +POMtgkYqg8X/T2OdQIDAQAB
  -----END PUBLIC KEY-----
  `;
            const nodersa = new NodeRSA(publicKey);
            nodersa.setOptions({ encryptionScheme: "pkcs1" });
            const postBody = nodersa.encrypt(postJson, "base64");
            lock = true; //锁定
            userWithdrawAlipay(postBody).then((res) => {
              if (res.resCode == 1) {
                layer.msg("操作成功！", { icon: 1 });
                setTimeout(function () {
                  self.$router.push({
                    path: "/account-center",
                  });
                }, 1000);
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
  },
};
</script>
<style lang="less">
@import "../../assets/css/bonusCash.less";
.input {
  min-width: 230px;
}
.code-sty {
  display: inline-block;
  padding: 5px 10px;
  background: #67c23a;
  border-radius: 2px;
  color: #fff;
  margin-left: 20px;
  cursor: pointer;
}
.grey-sty {
  background: #ddd;
  color: rgba(0, 0, 0, 0.65);
}
</style>



// WEBPACK FOOTER //
// bonusCash.vue?7981c894